exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".circleWithIcon---1QlP2 {\n  height: 100%;\n  width: 100%;\n  border-radius: 100%;\n  background: #1c7fc3; }\n\n.icon---3f9Mp {\n  width: 50%;\n  padding-top: 5px; }\n\n.icon---3f9Mp svg path {\n    fill: white !important; }\n", ""]);

// exports
exports.locals = {
	"circleWithIcon": "circleWithIcon---1QlP2",
	"icon": "icon---3f9Mp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/button/styles/circle-with-icon.scss
// module id = 1126
// module chunks = 3